import type { DataAction } from '../../../types/dataAction.type';
import { type CostFileSamplePayload, CostFileTemplateAdapterService } from '../services/CostFileTemplateAdapterService';

export const SET_COST_FILE_SAMPLE = 'SET_COST_FILE_SAMPLE' as const;

export type CostFileSample = {
  uploadedFile?: File;
  parsedCSV: Record<string, string>[];
};

export const setCostFileSample = ({ uploadedFile, parsedCSV }: CostFileSample) => {
  const costFileTemplateAdapter = new CostFileTemplateAdapterService();
  return {
    type: SET_COST_FILE_SAMPLE,
    data: costFileTemplateAdapter.fileToSample(uploadedFile, parsedCSV),
  };
};

export type SetCostFileSampleAction = DataAction<typeof SET_COST_FILE_SAMPLE, CostFileSamplePayload>;
